import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { Avatar } from '../core/Avatar';
import { Icon } from '../core/Icon';
import { propsDeAtivacao } from '../core/interativo';
import type { EventoDeAtivacao } from '../core/interativo';

export interface LeadCardProps {
    name?: string;
    /** Valor já formatado, ex.: "R$ 3.400". */
    value?: ReactNode;
    source?: ReactNode;
    owner?: string;
    tag?: ReactNode;
    dueLabel?: ReactNode;
    overdue?: boolean;
    onClick?: (e: EventoDeAtivacao) => void;
    style?: CSSProperties;
}

export function LeadCard({
    name, value, source, owner, tag, dueLabel, overdue = false, onClick, style,
}: LeadCardProps) {
    const [hover, setHover] = useState(false);
    const interacao = propsDeAtivacao(onClick, name ? `Abrir oportunidade ${name}` : 'Abrir oportunidade');

    return (
        <article
            {...interacao}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                background: 'var(--surface)', border: `1px solid ${hover ? 'var(--border-strong)' : 'var(--border)'}`,
                borderRadius: 'var(--radius-md)', padding: 12, display: 'flex', flexDirection: 'column', gap: 9,
                cursor: onClick ? 'pointer' : 'default', boxShadow: hover ? 'var(--shadow-sm)' : 'none',
                transition: 'var(--transition-control)', textAlign: 'left', ...style,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
                <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--text-primary)', lineHeight: '18px' }}>{name}</span>
                {value && <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{value}</span>}
            </div>
            {tag && (
                <span style={{ alignSelf: 'flex-start', fontSize: 11.5, fontWeight: 500, color: 'var(--neutral-700)', background: 'var(--surface-secondary)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-xs)', padding: '2px 7px' }}>
                    {tag}
                </span>
            )}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, fontSize: 12, color: 'var(--text-tertiary)' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                    {source && <><Icon name="radio" size={12} />{source}</>}
                </span>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    {dueLabel && (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: overdue ? 'var(--danger-strong)' : 'var(--text-tertiary)', fontWeight: overdue ? 600 : 400 }}>
                            <Icon name="clock" size={12} />
                            {dueLabel}
                        </span>
                    )}
                    {owner && <Avatar name={owner} size="xs" />}
                </span>
            </div>
        </article>
    );
}
